import { CourseDetailsResponse } from '../Types/CourseDetailsResponse';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from '../Actions/ActionTypes';
import { courseDetailsInitState } from './CourseInitState';

export const courseDetailsReducer = (
  state: CourseDetailsResponse = courseDetailsInitState,
  action: IAction<CourseDetailsResponse>
): CourseDetailsResponse => {
  switch (action.type) {
    case COURSE_ACTIONS.FETCH_COURSE_DETAILS:
      return { ...action.payload };

    case COURSE_ACTIONS.CLEAR_COURSE_DETAILS:
      return courseDetailsInitState;

    default:
      return state;
  }
};
